export enum VoucherStatusType {
    All = 0,
    Unredeemed = 1,
    Redeemed = 2
}
